module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/tankodrome-lvl1-100.0b2760bb.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/tankodrome-lvl1-100.png
// module id = 3552
// module chunks = 11